import {
  inject,
  isDevMode,
  LOCALE_ID,
  makeEnvironmentProviders,
} from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { APP_LOCALES } from './models/app-locales';

function localeServiceFactory(appLocales: string[]): string {
  if (isDevMode()) {
    return 'es';
  }

  const location = inject(PlatformLocation);
  const baseHref = location.getBaseHrefFromDOM();
  const locale = baseHref.replace(/\//g, '').trim();
  if (appLocales.includes(locale)) {
    return locale;
  }
  return 'es';
}

export function provideI18N() {
  return makeEnvironmentProviders([
    {
      provide: LOCALE_ID,
      useFactory: () => localeServiceFactory(APP_LOCALES),
    },
  ]);
}
